export const ALLOWED_EXTENSIONS = new Set([
    '.xml',
    '.swp',
    '.xlsx',
    '.xlsm',
    '.pdf',
    '.vsdx',
    '.rtf',
    '.pdf',
    '.jpeg',
    '.xls',
    '.jpg',
    '.conf',
    '.msg',
    '.csv',
    '.zip',
    '.bmp',
    '.gif',
    '.doc',
    '.png',
    '.lst',
    '.dat',
    '.html',
    '.docx',
    '.pptx',
    '.pptm',
    '.txt',
]);

const ALLOWED_MIME_TYPES = new Set([
    'application/xml', // xml
    'application/octet-stream', //swp, dat, bin
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
    `application/vnd.ms-excel.sheet.macroEnabled.12`, // xlsm
    'application/vnd.ms-excel', // xls
    'application/x-excel', // xls
    'application/excel', // xls
    'application/x-msexcel',
    `application/pdf`, // pdf
    'application/vnd.visio', // vsdx
    'application/vnd-ms-visio.drawing', // vsdx
    'application/rtf', //rtf
    'image/jpeg', // jpg and jpeg
    'application/xhtml+xml', // xml conf
    'text/plain', // txt, conf, log, etc.
    'application/vnd.ms-outlook', // msg
    'text/csv', //csv
    'application/csv', // csv
    'application/zip', // zip
    'image/bmp', // bmp,
    'image/gif', // gif
    'image/png', // png
    'application/msword', //doc
    'application/vnd.msword', //doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //docx
    'text/html', // html
    'application/vnd.ms-powerpoint', // ppt
    'application/powerpoint',
    'application/mspowerpoint',
    'application/x-mspowerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // pptx
]);

export function isValidFile(file: File): boolean {
    const { type = '', name = '' } = file;
    const realMime = type.split(';').shift()!; // eliminamos la versión y otros metadatos.
    const extension = name.split('.').pop()!;
    return ALLOWED_MIME_TYPES.has(realMime) || ALLOWED_EXTENSIONS.has(extension);
}
